/** URL of a model's `model.json`; production builds serve each `public/models/<name>/` from a content-hashed directory. */
export function modelUrl(name: string): string {
	const dir = __MODEL_DIRS__[name]
	if (!dir) throw new Error(`Unknown model "${name}": no public/models/${name}/ directory`)
	return `/models/${dir}/model.json`
}
